<template>
  <div>
    <home-nav></home-nav>
      <!-- 分割线 -->
    <div class="cut_off"></div>
    <div class="help_box">
      <!-- 左边区块 -->
      <div class="help_left">
        <!-- For-內容 -->
        <!-- 1 -->
        <div class="left_content">
          <!-- 標題 -->
          <div class="left_title">
            <div class="left_title_back">
              <!-- <router-link to="/">
                <i class="el-icon-back"></i>
              </router-link> -->
            </div>
            {{title}}
            <div class="left_title_author" >
            </div>
          </div>
          <!-- 標題-end -->
          <!-- 描述內容 -->
          <div class="left_describe">
            <p v-for="(item) of forList" :key='item.id'>
              <a :href="item.link" class="a_box">
                <span class="box_title">{{item.title}}</span>
                <span>{{item.createtime}}</span>
              </a>
            </p>
          </div>
          <!-- 描述內容-end -->
        </div>
        <!-- For-內容-end -->
      </div>
      <!-- 左边区块-end -->
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import axios from 'axios';
import HomeNav from './Nav.vue';
import HomeFooter from './Footer.vue';

export default {
  name: 'Help',
  props: {
    
  },
  data() {
    return {
      title: '',
      searchInput: '',
      activeIndex: '1',
      formHelp: {
        contentTF: true,
      },
      forList: [],
    }
  },
  methods: {
    clickFun(){
    },
  },
  components: {
    HomeNav,
    HomeFooter
  },
  created(){
    // 配置，开始跨域
    const instance=axios.create({
      withCredentials: true
    });
    // console.log(this.$route.params.id);
    instance.get(this.$store.state.axiosTestUrl, {
      params: {
        id: this.$route.params.id
      }
    }).then(res =>{
      // console.log(res.data);
      if(res.data){
        this.forList = res.data;
        this.title = res.data[0].name;
      } else {
        this.title = '我是title';
      }
    })
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*  */
  .cut_off {
    height: 4px;
		background: #e73262;
    margin-bottom: 30px;
  }
  .el-menu-vertical-demo {
    min-height: 550px;
  }
/* BOX */
  .help_box {
    width: 1200px;
    margin: 0 auto;
    border: 1px solid #c7c7c7;
    display: flex;
    margin-bottom: 30px;
    min-height: 550px;
  }
  .el_input {
    height: 20px;
  }
/* 左邊區塊 */
  .help_left {
    flex: 1;
    color: #333;
  }
  /* 文章標題 */
  .left_title {
    height: 74px;
    line-height: 74px;
    font-size: 23px;
    position: relative;
    text-align: center;
    margin: 0 20px;
    border-bottom: 1px solid #c7c7c7;
  }
  .left_title_author {
    color: #777;
    font-size: 19px;
    position: absolute;
    right: 0px;
    top: 0px;
  }
  .left_title_back {
    color: #777;
    font-size: 20px;
    position: absolute;
    left: 0px;
    top: 0px;
  }
  .left_describe {
    font-size: 13px;
    margin: 0 20px;
    min-height: 500px;
  }
  .left_describe > p {
    margin: 20px 0;
    line-height: 23px;
    border: 1px solid #777;
    border-radius: 4px;
  }
  .left_describe > p:hover {
    border: 1px solid #e73262;
  }
  .a_box {
    display: flex;
    flex-direction: column;
    padding: 10px;
  }
  .a_box .box_title {
    color: black;
  }

</style>
